import DebouncedInput from "./debounced";

export default function Filter({ filterFunc }: { filterFunc: (value: string | number) => void }) {
	
	return (
		<DebouncedInput type="text" id="simple-search" className="dark:bg-[#313131] border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-full pl-10 p-2  dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500" placeholder="Search Transaction" required value={''} onChange={filterFunc} />
	)
}